import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AuthNavbar from "../components/navigations/AuthNavbar";
import Sidebar from "../components/navigations/Sidebar";
import Dashboard from "../pages/provider/Dashboard";
import Settings from "../pages/provider/Settings";
import Claims from "../pages/provider/Claims";
import Policies from "../pages/provider/Policies";
import CreatePolicy from "../pages/provider/CreatePolicy";
import EditPolicy from "../pages/provider/EditPolicy";
import PolicyDetails from "../pages/provider/PolicyDetails";
import PurchaseManagement from "../pages/provider/PurchaseManagement";
import QuoteRequests from "../pages/provider/QuoteRequests";
import Earnings from "../pages/provider/Earnings";

export default function AuthRoutes() {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  return (
    <div className="flex flex-col h-screen">
      <AuthNavbar onMobileMenuToggle={toggleMobileSidebar} />
      <div className="flex overflow-hidden flex-1">
        <Sidebar isMobileOpen={isMobileSidebarOpen} onMobileToggle={toggleMobileSidebar} />
        <main className="overflow-y-auto flex-1">
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/claims" element={<Claims />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/policies/create" element={<CreatePolicy />} />
            <Route path="/policies/edit/:policy_slug" element={<EditPolicy />} />
            <Route path="/policies/view/:policy_slug" element={<PolicyDetails />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/profile" element={<Settings />} />
            <Route path="/purchase-management" element={<PurchaseManagement />} />
            <Route path="/quote-requests" element={<QuoteRequests />} />
            <Route path="/payout" element={<Earnings />} />
            <Route path="/teams" element={<div className="p-6">Team Management - Coming Soon</div>} />
            <Route path="/analytics" element={<div className="p-6">Report & Analytics - Coming Soon</div>} />
            <Route path="/notifications" element={<div className="p-6">Notifications Page - Coming Soon</div>} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
